import { pureJsCrypto } from './js.ts'

export const defaultCrypto = pureJsCrypto
